import { first } from 'rxjs/operators'
import { defineComponent } from 'vue'

import { Collaborator } from '@skinsoft/types'
import { aliasSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'

export const CollaboratorView = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['collaboratorId'],
    template: require('./collaborator-view.html'),
    data() {
        return {
            collaborator: null as any as Collaborator,
        }
    },
    computed: {
        formattedCollaboratorName(): string {
            let result = "";
            const firstName = aliasSelectors.firstName(this.collaborator, this.getAppLocale())
            const lastName = aliasSelectors.lastName(this.collaborator, this.getAppLocale())
            if (firstName) {
                result += firstName;
            }
            if (firstName && lastName) {
                result += " ";
            }
            if (lastName) {
                result += lastName
            }
            return result;
        },
    },
    methods: {
        subscribe() {
            if (this.collaboratorId) {
                this.subscribeTo(
                    this.$collaboratorDataStore.fetchOne(this.collaboratorId)
                        .pipe(first()),
                    collaborator => {
                        if (collaborator) {
                            this.collaborator = collaborator;
                        }
                    }
                )
            }
        },
    },
    watch: {
        collaboratorId: {
            handler() {
                this.unsubscribeFrom('collaborator-subscription')
                this.subscribe()
            },
            immediate: true,
        },
    },
})
